import { GeographyTypesEnum } from '../enum/geography-types.enum';

export class JournodexGetImmediateChildRegionModel {
    parentType: GeographyTypesEnum;
    parentId: number;
    childEntityTypeToSkip?: GeographyTypesEnum;
    locale: string;
}
